import { Badge } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

import { useStyle } from './styles';

export default function ProductApproved() {
  const classes = useStyle();
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const products = (notifications || []).find((n) => n.type === ENotificationType.APPROVED_PRODUCT);
  if (!products?.quantity) return null;

  return (
    <div>
      <Link to={`/producer/notifications/${ENotificationType.APPROVED_PRODUCT}`}>
        <div className={classes.content}>
          <div className={classes.type}>
            <h4>Produtos Aprovados</h4>
            <Badge badgeContent={products?.quantity || 0} color='secondary' classes={{ badge: classes.badgePosition }} showZero />
          </div>
        </div>
      </Link>
    </div>
  );
}
